__turbopack_context__.v({
  "card": "ec6bAW_card",
  "cardBody": "ec6bAW_cardBody",
  "cardImage": "ec6bAW_cardImage",
  "cardTitle": "ec6bAW_cardTitle",
});
